module.exports = __webpack_public_path__ + "static/media/analysis.e2241579.png";